import { Avatar, ButtonBase, Stack, Typography } from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useIsDesktop } from 'Hooks';
import { AppliesCloseButton, WhiteX } from 'Images';
import { FC } from 'react';

interface IAdvancedSearchPaper {
  closeAdvancedSearch: Function;
  height?: string;
  scroll?: boolean;
  advancedSearchOpen?: boolean;
}

export const AdvancedSearchPaper: FC<IAdvancedSearchPaper> = (props) => {
  const isDesktop = useIsDesktop();

  return (
    <Stack
      position={isDesktop ? 'relative' : 'fixed'}
      zIndex={isDesktop ? 1 : 1500}
      height={props.height ? props.height : isDesktop ? 'auto' : '100vh'}
      top={0}
      left={0}
      sx={{
        filter: 'drop-shadow(0px 2px 16px rgba(4, 16, 46, 0.08))',
        overflowY: props.scroll ? 'scroll' : undefined,
      }}
    >
      {isDesktop && (
        <ButtonBase
          aria-expanded={false}
          aria-controls={'advanced-search-paper'}
          onClick={() => props.closeAdvancedSearch(false)}
          sx={{
            borderRadius: '16px 16px 0 0',
            width: '138px',
            height: '65px',
            alignSelf: 'flex-end',
            top: '0',
            ':focus': {
              outline: '3px solid black',
            },
          }}
        >
          <Avatar
            src={AppliesCloseButton}
            sx={{
              height: '65px',
              width: '138px',
            }}
            alt={''}
            onClick={() => props.closeAdvancedSearch(true)}
          />
        </ButtonBase>
      )}
      <Stack
        bgcolor={isDesktop ? 'primary.shade_100' : '#fff'}
        border={'1px solid'}
        borderColor={'primary.shade_100'}
        borderRadius={isDesktop ? '16px 0 16px 16px' : 0}
        padding='24px'
        gap={'32px'}
      >
        {!isDesktop && (
          <Avatar
            alt={
              Dictionary[DICTIONARY.MedicalReferrals].search.advancedSearch
                .close
            }
            src={WhiteX}
            sx={{
              cursor: 'pointer',
              backgroundColor: 'purple2.main',
              alignSelf: 'flex-end',
              width: '32px',
              height: '32px',
              borderRadius: '50%',
            }}
            onClick={() => props.closeAdvancedSearch(false)}
          />
        )}
        <Typography variant={'h3'}>
          {Dictionary[DICTIONARY.MedicalReferrals].search.advancedSearch.title}
        </Typography>
        {props.children}
      </Stack>
    </Stack>
  );
};
